// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__6BK3x","title":"styles_title__LWTmD","subtitle":"styles_subtitle__iVMe8","form":"styles_form__RmmNl","submit":"styles_submit__a65DM"};